export default __webpack_public_path__ + "static/media/element0Card.69d544e4.svg";